import React , {useEffect} from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {  useSelector,useDispatch } from 'react-redux';
import { yupResolver } from "@hookform/resolvers/yup";
import { useSendForgetPassLinkMutation } from "../../../Services/api";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link} from "react-router-dom";
import PATHS from "../../../routes/paths";

export default function Login() {
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid")
  });
  const navigator = useNavigate();
  const {userDetail } = useSelector(
    (state) => state.auth
  )
    useEffect(()=>{
      if(userDetail){
        navigator(PATHS.studentDashboard);
      } ///
  },[userDetail,navigator])
  let defaultValues = { email: "", password: "" };
  const notify = () => '';
  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  const [SendForgetPassLink,isLoading] = useSendForgetPassLinkMutation();
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const onSubmit = (values) => {
    SendForgetPassLink({ data: values })
      .unwrap()
      .then((payload) => {
        
        if (payload.status) {
           
            if(payload.data===0 || payload.status===404){
             
              toast.error(payload.message)
            }
            else{
              toast.success(payload.message)
              navigator('/login');
            }
          
        } else {
       
          toast.error(payload.message)
        }
      })
      .catch((error) => {
        
        toast.error(error.data.message)
      });
      notify();
      
  };

  return (
    <>
      <main>
        <div className="container">
          <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                  <div className="d-flex justify-content-center py-4">
                    <img src="assets/img/logo.png" alt="" />
                    <h1 className="text-center">Forget Password</h1>
                  </div>
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="pt-4 pb-2">
                        <h5 className="card-title text-center pb-0 fs-4">ELEARNING </h5>
                      </div>
                      <form className="row g-3 needs-validation" >
                        <div className="col-12">
                          <label htmlFor="yourUsername" className="form-label">Email Address</label>
                          <div className="input-group has-validation">
                            <input type="email"  {...register("email")} className="form-control" id="yourUsername" />
                          </div>
                          <span className="text-danger">{errors.email?.message}</span>
                        </div>
                        <div className="col-12">
                            {isLoading.status !='pending' ? 
                                                
                                <button type="submit" className="btn btn-warning w-100" onClick={handleSubmit(onSubmit)}> Submit </button>
                                :
                                <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                              }
                          <p className="text-center">OR</p>
                          <p><Link to="/login">Login</Link></p>
                        </div>
                        <div className="col-12">
                        </div>
                      </form>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}